import axios from 'axios';

export default {
  template: "#vue-store-locator",
  delimiters: ['${', '}'],
  props: [],
  data: function () {
    return {
      stores: [],
      active_store: null,
      loading: true,
      coordinates: {},
      sports: '',
      services: ''
    }
  },
  created() {
    this.$store.commit("registerComponent", {name: 'store_locator', component: this})
  },
  methods: {
    switchSports: function (e) {
      this.services = ''
    },
    switchServices: function (e) {
      this.sports = ''
    },
    filterStoresResponse(stores) {
      let stores_out = []
      for (let store of stores) {
        if (store.distance > 100 && stores_out.length >= 3) {
          break
        } else {
          stores_out.push(store)
        }
      }
      this.stores = stores_out;
      if (this.stores.length > 0) {
        this.active_store = this.stores[0].store_number
      } else {
        this.active_store = null
      }
      this.loading = false;
    },
    updateClosestStores: function (lat = this.coordinates.lat, lng = this.coordinates.lng) {
      if (!(lat && lng)) {
        this.stores = [];
        this.loading = false;
        return
      }

      const coords = `${lat},${lng}`
      if (coords !== this.$store.getters.coords || this.sports || this.services) {
        let uri = `/apps/api/stores?coords=${lat},${lng}&radius=-1&exclude_warehouses=1`
        if (this.sports) {
          uri += `&sport=${this.sports}&language=${this.$store.state.lang}`
        }
        if (this.services) {
          uri += `&service=${this.services}&language=${this.$store.state.lang}`
        }
        axios.get(uri)
        .then(
            resp => {
              this.filterStoresResponse(resp.data)
              if (resp.data.length > 0) {
                this.$nextTick(() => {
                  this.$store.state.global_components.map.showLocationDetails(resp.data[0].store_number)
                })
              }
              dataLayer.push({
                event: 'store_search',
                store_query: {
                  position: coords !== this.$store.getters.coords ? coords : null,
                  sports: this.sports ? this.sports : null,
                  services: this.services ? this.services : null,
                  lang: this.$store.state.lang
                },
                store_results: resp.data.map(e => {
                  return {
                    store_number: e.store_number,
                    store_code: e.store_code,
                    fulfillment: e.fulfillment,
                    distance: e.distance
                  }
                })
              })
            },
            err => {
              console.error("error fetching stores:", err.response)
            })
      } else {
        this.$store.dispatch('getAllStores').then(
            resp => {
              this.filterStoresResponse(this.$store.getters.closest_stores.stores)
            },
            err => {
              console.error("error fetching closest stores:", err.response)
            }
            )
      }
    }
  },
  mounted: function () {
    this.$store.dispatch('getLocation').then(
        success => {
      this.coordinates = {lat: this.$store.state.location.latitude, lng: this.$store.state.location.longitude}
      this.updateClosestStores()
    }, () => {
    })
  }
}